/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Trips_Nudge_TitleInputs */

const en_ui_trips_nudge_title = /** @type {(inputs: Ui_Trips_Nudge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group sessions into trips`)
};

const de_ui_trips_nudge_title = /** @type {(inputs: Ui_Trips_Nudge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheiten zu Touren gruppieren`)
};

/**
* | output |
* | --- |
* | "Group sessions into trips" |
*
* @param {Ui_Trips_Nudge_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_trips_nudge_title = /** @type {((inputs?: Ui_Trips_Nudge_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Trips_Nudge_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_trips_nudge_title(inputs)
	return de_ui_trips_nudge_title(inputs)
});